import ManageWorkareas from './ManageWorkareas'
export default ManageWorkareas;